import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { firebase as fb, helpers } from 'redux-firebasev3';

import Loading from '../../components/Loading';
import ChannelRows from '../../components/ChannelRows';
import SlashCommand from '../../components/SlashCommand';
import SlashCommands from '../../components/SlashCommands';
import { channelsPath } from '../../utils/firebasePaths';

import S from './style.css';

const { isLoaded, isEmpty, dataToJS } = helpers;

@fb(({ teamId }) => [
  channelsPath(teamId)
])
@connect(
  ({ firebase }, { teamId }) => ({
    channels: dataToJS(firebase, channelsPath(teamId)),
  })
)
export default class ChannelList extends Component {
  static propTypes = {
    channels: PropTypes.object,
    children: PropTypes.node,
    client: PropTypes.string,
    firebase: PropTypes.object.isRequired,
    sortOptions: PropTypes.arrayOf(PropTypes.object),
    teamId: PropTypes.string.isRequired,
  }

  static defaultProps = {
    sortOptions: [
      { label: 'Most Recent', value: 'most-recent' },
      { label: 'Alphabetical', value: 'alphabetical' },
    ]
  }

  state = {
    sortValue: 'most-recent',
  }

  handleSelectChange = ({ target: { value } }) => {
    this.setState({ sortValue: value });
  }

  render() {
    const { channels, client, sortOptions, teamId } = this.props;
    const { sortValue } = this.state;

    if (!isLoaded(channels)) {
      return <Loading />;
    }

    const thClasses = 'tl pb2';
    const selectWrapperClasses = 'br2 dib v-mid pr3';

    return (
      <div>
        <div className="f5">
          <span className="b mr1 dn di-ns">Sort by:</span>
          <div className={`${S.selectWrapper} ${selectWrapperClasses}`}>
            <select
              className={`${S.select} ph2 pv1 gray`}
              onChange={this.handleSelectChange}
              value={sortValue}
            >
              {
                sortOptions.map(({ value, label }) => (
                  <option key={value} value={value}>{label}</option>
                ))
              }
            </select>
          </div>
        </div>
        <div className="cf mt2 mt4-ns ">
          <table className="collapse w-100">
            <thead>
              <tr className="bb b--black-10 dn dt-row-ns">
                <th className={thClasses} width="15%">Channel</th>
                <th className={thClasses} width="75%">Status</th>
                <th className={thClasses} width="7%">Actions</th>
              </tr>
            </thead>
            {!isEmpty(channels) &&
              <ChannelRows
                channels={channels}
                client={client}
                sortValue={sortValue}
                teamId={teamId}
              />
            }
          </table>
          {isEmpty(channels) &&
            <div className="mt3 tc">
              <div className="f4 tc lh-copy mb3">
                <div>
                  Welcome to your <SlashCommand /> dashboard! No statuses yet.
                </div>
                <div>
                  Here is a cheatsheet of the slash commands to get you started:
                </div>
              </div>
              <SlashCommands />
            </div>
          }
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/containers/ChannelList/index.jsx
 **/